
import { ExternalLinks } from '@/utils/external-navigation/constants';
import { StylePositionType, StyleSizeType, StyleColorSchemeType } from '@/ui-kit/styles/enums';
import { IconType } from '@/ui-kit/components/icon/enums';
import ExternalLink from '@/ui-kit/components/external-link';
import routes from '@/constants/routes';
import Icon from '@/ui-kit/components/icon';
import Button from '@/ui-kit/components/button';
import LazyImage from '@/components/lazy-image';
import ImageHelper from '@/utils/ImageHelper';
import WindowSize from '@/ui-kit/mixins/windowSize';
import { Comparator } from '@/ui-kit/enums';
import Gutter from '@/ui-kit/components/gutter';
import { track } from '@/utils/analytics';
import { TypographyType } from '@/ui-kit/components/typography/enums';
import Typography from '@/ui-kit/components/typography';
import Counter from '@/components/counter';
import { ImageSize, ActionType } from './enums';

export default {
  name: 'Steps',
  components: {
    ExternalLink,
    Icon,
    Button,
    LazyImage,
    Gutter,
    Counter,
    Typography,
  },
  mixins: [WindowSize],
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    actionType: {
      type: String,
      required: true,
      default: ActionType.Link,
    },
    linkText: {
      type: String,
      required: true,
    },
    linkUrl: {
      type: String,
      required: true,
    },
    image: {
      type: Object,
      default: () => {},
    },
    counter: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      routes,
      ExternalLinks,
      StylePositionType,
      StyleSizeType,
      StyleColorSchemeType,
      IconType,
      ImageSize,
      ActionType,
      TypographyType,
    };
  },
  computed: {
    imageRatio() {
      return ImageHelper.constructor.getImageRatio(this.image.dimensions);
    },
    stepsImageSizes() {
      return [
        {
          comparator: Comparator.Less,
          breakpoint: this.breakpoints.Small,
          imageSize: ImageSize.Small,
        },
        {
          comparator: Comparator.Greater,
          breakpoint: this.breakpoints.Medium,
          imageSize: ImageSize.Large,
        },
      ];
    },
    itemCount() {
      return this.counter + 1;
    },
  },
  methods: {
    trackEvent(title) {
      const type = this.$route.path === routes.sellYourHome ? 'Sell' : 'Buy';
      track(`${type} Your Home_${title} link click`);
    },
  },
};
